import { useFloatingPanelStore } from "@ui-kit/FloatingPanel";

export const AGENT_CHAT_PANEL_ID = "agent-chat";

export const useAgentChatIsOpen = () =>
	useFloatingPanelStore((state) => state.panels[AGENT_CHAT_PANEL_ID]?.isOpen ?? false);

export const setAgentChatIsOpen = (isOpen: boolean) =>
	useFloatingPanelStore.getState().setIsOpen(AGENT_CHAT_PANEL_ID, isOpen);
